<input
  type="file"
  accept="image/jpeg,image/png,image/gif"
  onclick="this.value = null"
  (change)="fileChangeEvent($event)"
  #fileInput
/>
<ng-template #dialog let-data let-ref="dialogRef">
  <nb-card [nbSpinner]="showSpinner">
    <nb-card-header *ngIf="showCropper">EDIT</nb-card-header>
    <nb-card-body>
      <div>
        <image-cropper
          [imageChangedEvent]="imageChangedEvent"
          [maintainAspectRatio]="true"
          [containWithinAspectRatio]="containWithinAspectRatio"
          [aspectRatio]="1"
          [resizeToWidth]="resizeToWidth"
          [cropperMinWidth]="cropperMinWidth"
          [onlyScaleDown]="true"
          [roundCropper]="false"
          [canvasRotation]="canvasRotation"
          [transform]="transform"
          [alignImage]="'center'"
          [style.display]="showCropper ? null : 'none'"
          [format]="format"
          [imageQuality]="92"
          backgroundColor="white"
          [autoCrop]="false"
          (imageCropped)="imageCropped($event)"
          (imageLoaded)="imageLoaded()"
          (cropperReady)="cropperReady($event)"
          (loadImageFailed)="loadImageFailed()"
        ></image-cropper>
      </div>
    </nb-card-body>
    <nb-card-footer *ngIf="showCropper" class="text-right">
      <!--      <button (click)="rotateLeft()">Rotate left</button>-->
      <!--      <button (click)="rotateRight()">Rotate right</button>-->
      <!--      <button (click)="flipHorizontal()">Flip horizontal</button>-->
      <!--      <button (click)="flipVertical()">Flip vertical</button>-->
      <button nbButton status="info" (click)="onDialogOk(); ref.close(true)">
        <nb-icon icon="checkmark-outline"></nb-icon>OK
      </button>
      <button nbButton status="basic" (click)="ref.close()"><nb-icon icon="close-outline"></nb-icon>Cancel</button>
    </nb-card-footer>
  </nb-card>
</ng-template>
